import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { rescheduleGuest } from '../../../api/sportaloka-client';

const ExecutionModal = ({ resetData, guestId }) => {
  const [date, setDate] = useState('');
  const [loading, setLoading] = useState(false);
  const handleSubmit = async () => {
    if (!date) {
      Swal.fire({
        title: 'Gagal!',
        text: `Tanggal jadwal berikutnya wajib diisi`,
        icon: 'error',
        confirmButtonText: 'Tutup'
      });
      return false;
    }

    try {
      setLoading(true);
      await rescheduleGuest(guestId, date);
      document.getElementById('closeModal').click();
      resetData();
      Swal.fire({
        title: 'Berhasil!',
        text: `Jadwal berikutnya telah diperbaharui`,
        icon: 'success',
        confirmButtonText: 'Tutup'
      });
      setLoading(false);
    } catch (error) {
      Swal.fire({
        title: 'Gagal!',
        text: `Periksa koneksi internet anda`,
        icon: 'error',
        confirmButtonText: 'Tutup'
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleModalHidden = () => {
      setDate('');
    };

    const modalElement = document.getElementById('executionModal');
    modalElement.addEventListener('hidden.bs.modal', handleModalHidden);

    return () => {
      modalElement.removeEventListener('hidden.bs.modal', handleModalHidden);
    };
  }, []);
  return (
    <div className="modal" tabIndex="-1" id="executionModal">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title fw-600 text-16">Penjadwalan Ulang Sisa Tamu</h5>
            <button
              id="closeModal"
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <div className="mb-20 px-20">
              {/* <h5 className="text-center text-blue-1">
                Penjadwalan Ulang Semua Tamu yang Belum Terlaksana
              </h5> */}
            </div>
            <label className="fw-500" htmlFor="">
              Pilih Tanggal Pelaksanaan Berikutnya
            </label>
            <input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              className="form-control"
              style={{ marginTop: 8, border: '1px solid #ced4da', backgroundColor: '#f2f2f2' }}
            />
          </div>
          <div className="modal-footer d-flex justify-content-center">
            <button
              disabled={loading}
              onClick={handleSubmit}
              type="button"
              className="btn btn-primary bg-blue-1 rounded-1 fw-600">
              {loading ? 'Loading...' : 'Simpan'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExecutionModal;
